import { SanityMicroContentExcursionsActivityLevel } from "@silversea-ssc/system-components-react/ShorexDrawer/utils";
import { isPresent } from "src/utils/checks";
import { SanityMicroContentExcursionActivityLevel } from "types/graphql-types";

type PartialLocalizedMicroContent<T> = T extends {
  _key?: string;
  code?: string;
  label?: { localized?: string };
  content?: { localized?: string };
}
  ? T
  : never;

type ActualLocalizedMicroContent<T> = Omit<
  PartialLocalizedMicroContent<T>,
  "label" | "content" | "_key" | "code"
> & {
  _key: string;
  code: string;
  label?: string | undefined;
  content?: string | undefined;
};

export function toLocalizedMicroContents<T>(
  microContents: (PartialLocalizedMicroContent<T> | undefined)[] | undefined
) {
  return (microContents || []).map(localizedMicroContent).filter(isPresent);
}

function localizedMicroContent<T>(
  microContent: PartialLocalizedMicroContent<T> | undefined
): ActualLocalizedMicroContent<T> | undefined {
  if (!microContent) return undefined;

  const { label, content, _key, code, ...rest } = microContent;
  if (!_key || !code) return undefined;

  return {
    ...rest,
    _key,
    code,
    label: label?.localized
  };
}

export function toLocalizedActivityLevelsMicroContents(
  microContents:
    | (SanityMicroContentExcursionActivityLevel | undefined)[]
    | undefined
) {
  return (microContents || [])
    .map(localizedActivityLevelsMicroContents)
    .filter(isPresent);
}

const localizedActivityLevelsMicroContents = (
  microContent: SanityMicroContentExcursionActivityLevel | undefined
): SanityMicroContentExcursionsActivityLevel | undefined => {
  if (!microContent) return undefined;

  const { label, content, _key, iconStep, ...rest } = microContent;
  if (!_key || !iconStep) return undefined;

  return {
    ...rest,
    _key,
    iconStep,
    code: iconStep.toString(),
    label: label?.localized
  };
};
